module.exports = __webpack_public_path__ + "static/media/sn.6d85da96.svg";